import { render, staticRenderFns } from "./ModalEditProductGP.vue?vue&type=template&id=b8bf0a82&scoped=true&"
import script from "./ModalEditProductGP.vue?vue&type=script&lang=js&"
export * from "./ModalEditProductGP.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditProductGP.vue?vue&type=style&index=0&id=b8bf0a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bf0a82",
  null
  
)

export default component.exports